import { useContext, memo } from 'react';
import { useDateUtils } from '../../../Utilities/useDateUtils';
import { useTranslation } from 'react-i18next';
import CommentsTable from './CommentsTable';
import ReasonFilter from './CommentsReasonFilter';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';

const CommentsSection = memo(function CommentsSection() {
    const { t } = useTranslation();
    const { lotDetail: { comments } } = useContext(LotDetailContext);
    const { convertUTCToShortDateTimeSecs } = useDateUtils();

    const tableColumns = [
        {
            Header: t('LotDetails.Comments.CommentDate'),
            accessor: 'commentDateUtc',
            Cell: (props) => convertUTCToShortDateTimeSecs(props.value)
        },
        {
            Header: t('LotDetails.Comments.Account'),
            accessor: 'account'
        },
        {
            Header: t('LotDetails.Comments.Reason'),
            accessor: 'reason',
            Filter: ReasonFilter,
            filter: "jsonArray"
        },
        {
            Header: t('LotDetails.Comments.Comment'),
            accessor: 'commentText',
            Cell: (props) => {
                return <p className="text-break">{props.value}</p>;
            }
        }
    ];

    const initialState = {
        sortBy: [
            {
                id: 'commentDate',
                desc: true
            }
        ]
    };

    let table = <CommentsTable columns={tableColumns} data={comments} initialState={initialState} />;

    return comments?.length > 0
        ? table
        : <span>{t('CommonResponses.NoData')}</span>;
});

export default CommentsSection;